/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { type AxiosRequestConfig } from "axios";
import { env } from '$env/dynamic/public';
import type { FloraSignal } from "./type";
import { axiosHandler } from "../axiosHandler";

export const sendSignal = async (requestData: FloraSignal, token: string): Promise<boolean> => {
    try {
        const config: AxiosRequestConfig = {
            method: 'POST',
            url: `${env.PUBLIC_FLORA_DIRECT}/signal`,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
            data: requestData,
        };
        await axiosHandler(config);
        return true;
    } catch (error) {
        console.log('error -> sendSignal', error);
        return false;
    }
}